export class Params4Post{
    constructor(Param1?: string,
        Param2?: string,
         Param3?: string,
         Param4?: string,
         Param5?: string,
        Param6?: string,
        Param7?: string,
        Param8?: string,
        Param9?: string,
        Param10?: string
        ){
        this.Param1 = Param1;
        this.Param2 = Param2;
        this.Param3 = Param3;
        this.Param4 = Param4;
        this.Param5 = Param5;
        this.Param6 = Param6;
        this.Param7 = Param7;
        this.Param8 = Param8;
        this.Param9 = Param9;
        this.Param10 = Param10;
    }
    Param1: string;
    Param2: string;
    Param3: string;
    Param4: string;
    Param5: string;
    Param6: string;
    Param7: string;
    Param8: string;
    Param9: string;
    Param10: string;
}